<!--
 * @Author: Ashley.Liu
 * @Date: 2022-02-23 14:48:40
 * @LastEditTime: 2022-03-01 19:06:41
 * @Description: router or multi tab
-->
<template>
  <div class="app-main">
    <template v-if="!showMultiTab">
      <keep-alive>
        <!-- 需要缓存的视图组件 -->
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
      <!-- 不需要缓存的视图组件 -->
      <router-view v-if="!$route.meta.keepAlive"></router-view>
    </template>
    <keep-alive
      v-else
      :include="includeList"
    >
      <template v-if="$route.meta.useIndependentInstance === true">
        <template v-for="(tab,index) in list">
          <component
            :key="`${tab.path}${index}`"
            :is="tab.component"
            v-bind="tab.query"
            v-if="activeTab.uuid === tab.uuid"
          ></component>
        </template>
      </template>
      <router-view v-else></router-view>
    </keep-alive>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'AppMain',
  data () {
    return {
      showMultiTab: false,
      activeTab: {}
    }
  },
  computed: {
    ...mapState('multiTabs', ['list', 'current']),
    includeList () {
      const includes = this.list.filter(item => item.meta.keepAlive !== false)
      const list = includes.map(item => {
        return item.name
      })
      return list
    }
  },
  watch: {
    current: {
      deep: true,
      immediate: true,
      handler (v) {
        this.showMultiTab = !!v
        this.activeTab = this.list.find(item => item.uuid === v?.uuid)
      }
    }
  }
}
</script>

<style scoped>
.app-main {
  /*84 = navbar + tags-view = 50 +34 */
  display: block;
  height: calc(100vh - 100px);
  width: 100%;
  position: relative;
}
</style>
